import DateRangeFacet from 'govbr.frontend.policy/components/Blocks/Search/components/DateRangeFacet';

export default DateRangeFacet;
